import { getAuthTokensService } from './AuthTokensService';

const API_BASE_URL = import.meta.env.VITE_DARWIN_API_BASE_URL || 'https://api.staging.darwingov.com';

export const authService = {
  refreshToken: async () => {
    const authTokensService = getAuthTokensService();
    const refreshToken = authTokensService.getRefreshToken();
    
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const response = await fetch(`${API_BASE_URL}/api/auth/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    if (!response.ok) {
      throw new Error('Failed to refresh token');
    }

    const data = await response.json();
    
    // Transform the response to match the expected token format
    return {
      token: data.access_token,
      roles: data.user?.roles || [],
      tenant_id: data.user?.tenant_id || '',
    };
  },

  logout: async () => {
    try {
      await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (error) {
      console.error('Logout API call failed:', error);
    } finally {
      // Always clear tokens regardless of API call success
      const authTokensService = getAuthTokensService();
      await authTokensService.clearTokens();
    }
  },
};